import axios from "axios";
// import session from "../session";
import util from "@/js/util";
import { useLoading } from 'vue-loading-overlay';

export default class AxiosManager {

    constructor(tokenCookieKey) {
        this._tokenCookieKey = tokenCookieKey;

        const loadingInstance = useLoading();

        let loader; // 用於儲存 Loading 實例

        // 添加請求攔截器
        axios.interceptors.request.use(
            (config) => {
                // 顯示 Loading Overlay
                loader = loadingInstance.show();
                return config;
            },
            (error) => {
                // 發生錯誤，隱藏 Loading
                if (loader) loader.hide();
                return Promise.reject(error);
            }
        );

        // 添加響應攔截器
        axios.interceptors.response.use(
            (response) => {
                // 成功響應，隱藏 Loading
                if (loader) loader.hide();
                return response;
            },
            (error) => {
                // 發生錯誤，隱藏 Loading
                if (loader) loader.hide();
                return Promise.reject(error);
            }
        );

    }

     get (url, data) {
        let res= this.axios_get(url,data);

        return res;
    }

     post_json (url, data,postAuth) {
        let contentType="application/json; charset=utf-8";

        let formData = new FormData()
        Object.keys(data).forEach(key => {
            formData.append(key, data[key])
        })

        let res= this.axios_post(url,formData,contentType,postAuth);

        return res;
    }

     post_form (url, data) {
        let contentType="application/json; charset=utf-8";

        let res= this.axios_post(url,data,contentType);

        return res;
    }

     post_file (url,file, data) {
        // let contentType="";

        let formData = new FormData()
        Object.keys(data).forEach(key => {
            formData.append(key, data[key])
        })

        formData.append("file", file);

        let res= this.axios_post(url,formData);

        return res;
    }

     post_files (url,file, data) {
        // let contentType="application/x-www-form-urlencoded; charset=utf-8";
        let contentType="multipart/form-data";

        let formData = new FormData()
        Object.keys(data).forEach(key => {
            formData.append(key, data[key])
        })

        formData.append('file', file);
        // formData.append("files", files);

        let res= this.axios_post(url,formData,contentType);

        return res;
    }

    axios_get (url, data) {
        return new Promise((resolve,reject) => {// eslint-disable-line
            // axios.defaults.adapter = require('axios/lib/adapters/http')
            axios.defaults.withCredentials=true

            let axiosConfig={
                headers: {
                    withCredentials: true,
                },
            };

            // let token=session.getTokenByKey(this._tokenCookieKey)
            // if (token){
            //     axiosConfig.headers.Authorization="Bearer " +token
            // }

            // axiosConfig.headers.CC=process.env.VUE_APP_publicPath
            // axiosConfig.headers.ST=process.env.VUE_APP_siteType
            // axiosConfig.headers.HH=location.host

            axios.get(url, {params: data,axiosConfig})
                .then((res)=>{
                    resolve(res)
                }).catch((err)=>{
                // reject(err);
                this.handleError(err);
            })
        })
    }

    axios_post (url, formData,contentType,postAuth) {
        return new Promise((resolve,reject) => { // eslint-disable-line
            let axiosConfig = undefined;

            axiosConfig={
                headers: {
                    'Content-Type': contentType,
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
                    "Access-Control-Allow-Headers": "Origin, Content-Type, Authorization",
                    // 'Authorization': "Bearer " + session.getToken(),
                },
            };

            // let token=session.getTokenByKey(this._tokenCookieKey)
            let token=localStorage.getItem(this._tokenCookieKey);
            if (token){
                if (postAuth ===undefined ){
                    axiosConfig.headers.Authorization="Bearer " +token      //一般用
                    // axiosConfig.headers['X-Token']=token        //asp.net core用
                }else{
                    if (postAuth){
                        //login時，不要帶jwt
                        axiosConfig.headers.Authorization="Bearer " +token//一般用
                        // axiosConfig.headers['X-Token']=token        //asp.net core用
                    }
                }
            }

            // axiosConfig.headers.CC=process.env.VUE_APP_publicPath
            // axiosConfig.headers.ST=process.env.VUE_APP_siteType
            // axiosConfig.headers.HH=location.host

            // axios.defaults.adapter = require('axios/lib/adapters/http')
            axios.defaults.withCredentials=true

            axios.post(url, formData,axiosConfig)
                .then((res)=>{
                    resolve(res)
                }).catch((err)=>{
                // reject(err);
                this.handleError(err);
            })
        })
    }

    handleError(error){
        if (error.response) {
            if (error.response.status === 503) {
                // 显示服务不可用提示
                util.ShowMessageThenRefresh(error.response.data.message || "系統忙碌中，請稍後再試。");
                return;
            }

            if (error.response.status === 401) {
                // 显示服务不可用提示
                util.ShowMessageThenRefresh(error.response.data.message || "請重新登入。!");
                window.location.href = "/Login";
                return;
            }

            if (error.response.status === 403) {
                // 显示服务不可用提示
                util.ShowMessageThenRefresh(error.response.data.message || "請重新登入。");
                window.location.href = "/Login";
                return;
            }
        }

        //err.response.data.message   exception message (開發人員給定的)
        //err.response.status 500
        //err.response.statusText Internal Server Error
        let errMsgToShow="";
        let exceptionMsg = error?.response?.data?.message;

        if (exceptionMsg){
            errMsgToShow=exceptionMsg;
        }else{
            errMsgToShow=error.message;
        }

        util.ShowMessage("優惠券讀取失敗，請依步驟檢查重新進入<br/>" +
            "1.確認網路連線正常<br/>" +
            "2.確認手機時間設定為自動偵測<br/>" +
            "3.關閉APP背景執行並重新開啟 <br/>" + "(" + this.timeNow() +"):" +errMsgToShow);
    }
    timeNow() {
        var d = new Date(),
            h = (d.getHours()<10?'0':'') + d.getHours(),
            m = (d.getMinutes()<10?'0':'') + d.getMinutes();
        return  h +""+ m;
    }
}

